import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchase-logs-card',
  templateUrl: './purchase-logs-card.component.html',
  styleUrls: ['./purchase-logs-card.component.scss']
})
export class PurchaseLogsCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
